import { useEffect, useState } from "react";
import classNames from "classnames";
import { Tab } from "components/molecules/Tab";
import { CourseIndexTextOptionBtn } from "../CourseIndexTextOptionBtn";
import { CourseIndexTabClassHomeWork } from "components/organisms/CourseIndexTabClassHomeWork";
import { DropDown, Typography } from "components/atoms";
import { useAppSelector, useScreenSize } from "hooks";
import { DESKTOP_WIDTH, MOBILE_WIDTH } from "utils/constants";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import "./index.scss";

interface IProps {
  borderColor: string;
  isTabShow: boolean;
  groups?: any;
  groupNames?: Array<any> | any;
  drillSmartContent?: any[];
  styles?: string;
  title: string;
  timeSpan?: string;
  profileImage?: string;
  messageIcon?: boolean;
  btnLabel?: string;
  theme: "light" | "dark";
}

export const CourseIndexDetailCard = ({
  borderColor = "black",
  isTabShow,
  title = "Test 4",
  groupNames,
  groups,
  drillSmartContent,
  theme,
}: IProps) => {
  const [filterDropdownSelection, setFilterDropdownSelection] = useState<
    null | string | { [key: number]: string }
  >(null);
  const screen = useScreenSize();

  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );

  let hasSmallScreenWithChatDrawerOpen =
    screen.width > DESKTOP_WIDTH &&
    screen.width < 1600 &&
    aiMCATChatDrawerStatus === "open";

  useEffect(() => {
    if (!groups) {
      setFilterDropdownSelection(null);
      return;
    }
    const keys = Object.keys(groups);
    const firstKey = keys[0];

    setFilterDropdownSelection((prev) => {
      if (prev == null) {
        return firstKey != null ? { 0: firstKey } : null;
      }
      const currentKey = Object.values(prev)[0];
      const stillValid = keys.includes(currentKey);
      return stillValid ? prev : (firstKey != null ? { 0: firstKey } : null);
    });
  }, [groups]);

  return (
    <div className="course-index-tile-container">
      <div
        className={classNames(
          "course-index-tile-wrapper",
          `course-index-default-border-${borderColor}`
        )}
      >
        <div className="tile-container">
          <div className={classNames("content-section")}>
            <div className="content-1">
              <Typography
                label={title}
                variant={
                  screen.width <= MOBILE_WIDTH ||
                  hasSmallScreenWithChatDrawerOpen
                    ? "h7Bold"
                    : "h5Bold"
                }
              />
            </div>
          </div>
          {isTabShow ? (
            screen.width <= MOBILE_WIDTH || hasSmallScreenWithChatDrawerOpen ? (
              <div className="course-index-mobile-container">
                <div className="course-index-mobile-drop-down-wrapper">
                  {groupNames && Array.isArray(groupNames) ? (
                    <DropDown
                      data={[...Object.keys(groups).map((group: any) => group)]}
                      styles="drop-down-custom-style"
                      setDropDownSelection={setFilterDropdownSelection}
                      defaultSelected={filterDropdownSelection}
                      placeholder="Select"
                    />
                  ) : null}
                </div>
                <div className="course-index-mobile-tabs-contain-wrapper">
                  <CourseIndexTextOptionBtn
                    isMobile={
                      screen.width <= MOBILE_WIDTH ||
                      hasSmallScreenWithChatDrawerOpen
                    }
                    exams={(() => {
                      const groupKey = filterDropdownSelection && Object.values(filterDropdownSelection)[0];
                      const groupItems = (groupKey && groups?.[groupKey]) || [];
                      const drillSmartForGroup = (drillSmartContent || []).filter((ds: any) => (ds.GroupName ?? ds.groupName) === groupKey).map((ds: any) => ({ ...ds, _isDrillSmartGrouping: true }));
                      return [...(groupItems || []), ...drillSmartForGroup];
                    })()}
                    theme={theme}
                    title={title}
                  />
                </div>
              </div>
            ) : (
              <div className="tab-section">
                {groupNames && Array.isArray(groupNames) ? (
                  <Tab
                    tabTitles={[
                      ...Object.keys(groups).map(
                        (group: any, index: number) => (
                          <p
                            key={index}
                            id={`course-index-${group.toLowerCase()}`}
                          >
                            {group}
                          </p>
                        )
                      ),
                    ]}
                    tabContents={[
                      ...Object.keys(groups).map(
                        (group: any, index: number) => {
                          const groupItems = groups[`${group}`] || [];
                          const drillSmartForGroup = (drillSmartContent || []).filter((ds: any) => (ds.GroupName ?? ds.groupName) === group).map((ds: any) => ({ ...ds, _isDrillSmartGrouping: true }));
                          return (
                            <CourseIndexTabClassHomeWork
                              key={index}
                              isBtn={true}
                              isMobile={
                                screen.width < MOBILE_WIDTH ||
                                hasSmallScreenWithChatDrawerOpen
                              }
                              exams={[...groupItems, ...drillSmartForGroup]}
                              type={group}
                              theme={theme}
                              title={title}
                            />
                          );
                        }
                      ),
                    ]}
                    defaultActiveTab={0}
                  />
                ) : null}
              </div>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};
